// extracted by css-extract-rspack-plugin
export default {"cls1":"VideoPlayerMainContent-cls1_RUD","cls2":"VideoPlayerMainContent-cls2_dCw VideoPlayerMainContent-cls1_RUD"};